<template>
  <div v-if="cardActivationEnhancementsFooterEnabled" class="footer-section">
    <ClientOnly>
      <CreditcardBannerConsumableCreditCardBanner
        source="footer"
        :card-activation-enhancements-enabled="cardActivationEnhancementsEnabled"
        card-activation-enhancements-header-footer-enabled
        bringback-page="CreditGateway"
        credit-acquisition="footer"
      />
    </ClientOnly>
  </div>
  <section v-else class="sign-up">
    <div v-if="creditCardData" @click="popupLinkHandler">
      <div class="heavy">
        <span v-if="offerHeading">{{ offerHeading }}</span>
        <span v-else>Apply for a Bloomingdale's Credit Card</span>
      </div>
      <div class="footer-card-content margin-top-xs">
        <div class="cell credit-card-img margin-right-xs">
          <Picture
            image-url="https://images.bloomingdalesassets.com/is/image/BcomMedia/media/screenshot1_1649967259796.png"
            alt=""
            :using-scene7="false"
          />
        </div>
        <div>
          <div v-for="(paragraph, index) in offerContent" :key="index" class="small">
            <!-- eslint-disable vue/no-v-html -->
            <div v-if="index === offerContent.length - 1" class="container-with-actions margin-top-xxs">
              <div v-if="paragraph" v-html="paragraph"></div>
              <template v-for="action in offerActions" :key="action.value">
                <CommonLink :href="action.value">
                  {{ action.text }}
                </CommonLink>
              </template>
            </div>
            <div v-else v-html="paragraph"></div>
            <!-- eslint-enable -->
          </div>
        </div>
      </div>
    </div>
    <Skeleton v-else :height="'114px'" />
  </section>
</template>

<script setup>
/* v8 ignore file -- @preserve */
import { computed, defineAsyncComponent } from 'vue';

import Picture from '@nuxt-common/atomic-ui/app/components/picture/Picture';
import Skeleton from '@nuxt-common/atomic-ui/app/components/skeleton/Skeleton';

import { GET_CREDIT_CARD_DATA } from '#shared/types/getters';
import { usePopupLink } from '~/composables/features/usePopupLink';
import useKillswitches from '~/composables/useKillswitches';
import CreditCardBannerSkeleton from './CreditCardBannerSkeleton.vue';

const CreditcardBannerConsumableCreditCardBanner = defineAsyncComponent({
  loader: () => import('@nuxt-common/creditcard-banner-consumable/app/components/CreditCardBanner.vue'),
  loadingComponent: CreditCardBannerSkeleton,
});

const { popupLinkHandler } = usePopupLink();
const killswitches = useKillswitches();
const cardActivationEnhancementsEnabled = computed(() => killswitches?.value?.cardActivationEnhancementsEnabled);
const cardActivationEnhancementsFooterEnabled = computed(() => killswitches?.value?.cardActivationEnhancementsFooterEnabled);
const navFooter = useNavFooter();
const creditCardData = computed(() => navFooter?.[GET_CREDIT_CARD_DATA]);

const getFromCreditCardData = (key) => computed(() => creditCardData.value?.[key]);
const offerHeading = getFromCreditCardData('heading');
const offerContent = computed(() => {
  const rawContent = creditCardData.value?.content;
  if (!rawContent) return [];
  return rawContent.split(/<\/p>\s*<p>/).map((p) => p.replace(/<[^>]*>/g, ''));
});
const offerActions = getFromCreditCardData('actions');
</script>

<style scoped lang="scss" brand="bcom">
.small-link {
  cursor: pointer;
  text-decoration: underline;
}

.footer-card-content {
  display: flex;
  flex-flow: row nowrap;
}

.credit-card-img {
  width: 57px;
}

.container-with-actions {
  display: flex;
  flex-wrap: wrap;
  column-gap: 8px;
}
</style>
